module.exports = __webpack_public_path__ + "media/images/emblems/Oeschenbach-coat_of_arms-b4450fa420152edd1930a28759146142.svg";